// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import sanitizeHtml from "sanitize-html";
// import Header from "../components/Header";
// import Footer from "../components/Footer";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

// const SingleBlogPage = () => {
//   // const { blogId } = useParams();
//   const navigate = useNavigate();
//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const { slug } = useParams();

// // extract ID from slug
// const blogId = slug.split("-").pop();

//   useEffect(() => {
//     const fetchBlog = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/blogs`);
//         const allBlogs = res.data || [];
//         const foundBlog = allBlogs.find((b) => String(b.blog_id) === blogId);
//         setBlog(foundBlog || null);
//       } catch (err) {
//         console.error("Error fetching blog:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBlog();
//   }, [blogId]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex justify-center items-center">
//         <p className="text-gray-500 text-sm sm:text-base">Loading blog...</p>
//       </div>
//     );
//   }

//   if (!blog) {
//     return (
//       <div className="min-h-screen flex flex-col">
//         <Header />
//         <div className="flex-1 flex flex-col justify-center items-center text-center px-4">
//           <p className="text-gray-500 text-base sm:text-lg mb-4">
//             Blog not found or has been removed.
//           </p>
//           <button
//             onClick={() => navigate("/blogs")}
//             className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold text-sm sm:text-base"
//           >
//             Back to Blogs
//           </button>
//         </div>
//         <Footer />
//       </div>
//     );
//   }

//   const sanitizedContent = sanitizeHtml(blog.blog_description, {
//     allowedTags: [
//       "p", "strong", "b", "i", "em", "u",
//       "ul", "ol", "li", "br",
//       "h1", "h2", "h3", "blockquote", "a", "img"
//     ],
//     allowedAttributes: {
//       a: ["href", "target"],
//       img: ["src", "alt"],
//     },
//   });

//   return (
//     <div className="min-h-screen bg-white flex flex-col">
//       <Header />

//       {/* HERO SECTION */}
//       <section className="pt-24 sm:pt-28 md:pt-36 pb-8 px-4 text-center bg-gradient-to-br from-green-50 to-blue-50">
//         <div className="mx-auto max-w-3xl">
//           <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
//             {blog.blog_name}
//           </h1>
//           <div className="h-1 w-20 bg-green-600 mx-auto mb-4 rounded"></div>
//           <p className="text-gray-500 text-sm sm:text-base italic">
//             Published on: {new Date().toLocaleDateString()}
//           </p>
//         </div>
//       </section>

//       {/* BLOG CONTENT */}
//       <section className="py-10 sm:py-14 px-4">
//         <div className="max-w-4xl mx-auto text-left">
//           {blog.blog_image && (
//             <img
//               src={blog.blog_image}
//               alt={blog.blog_name}
//               className="w-full aspect-video object-cover rounded-xl mb-8 shadow-lg"

//             />
//           )}

//           <div
//           className="prose max-w-none text-gray-800 leading-relaxed text-justify"
//             dangerouslySetInnerHTML={{ __html: sanitizedContent }}
//           ></div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-10 bg-gradient-to-r from-green-100 to-blue-100 text-center">
//         <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">
//           Want to Read More?
//         </h2>
//         <button
//           onClick={() => navigate("/blogs")}
//           className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold text-sm sm:text-base"
//         >
//           Back to All Blogs
//         </button>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default SingleBlogPage;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import sanitizeHtml from "sanitize-html";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../App.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const SingleBlogPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Extract blog ID safely
  const slugify = (text = "") =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    const fetchBlog = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/blogs`);
        const allBlogs = res.data || [];

        const foundBlog = allBlogs.find((b) => slugify(b.blog_name) === slug);

        setBlog(foundBlog || null);
      } catch (err) {
        console.error("Error fetching blog:", err);
        setBlog(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  // ✅ Clean & sanitize HTML
  const sanitizedContent = blog
    ? sanitizeHtml(blog.blog_description, {
        allowedTags: [
          "p",
          "strong",
          "b",
          "i",
          "em",
          "u",
          "ul",
          "ol",
          "li",
          "br",
          "h1",
          "h2",
          "h3",
          "blockquote",
          "a",
          "img",
        ],
        allowedAttributes: {
          a: ["href", "target"],
          img: ["src", "alt"],
        },
        textFilter: function (text) {
          return text.replace(/\s+/g, " "); // ✅ remove extra spaces
        },
      })
    : "";

  // ✅ Loading UI
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <p className="text-gray-500 text-sm sm:text-base">Loading blog...</p>
      </div>
    );
  }

  // ✅ Not Found UI
  if (!blog) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-1 flex flex-col justify-center items-center text-center px-4">
          <p className="text-gray-500 text-base sm:text-lg mb-4">
            Blog not found or has been removed.
          </p>
          <button
            onClick={() => navigate("/blogs")}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold text-sm sm:text-base"
          >
            Back to Blogs
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const fixOrderedLists = (html) => {
    if (!html) return "";

    let fixed = html;

    // Step 1: merge multiple ordered lists
    fixed = fixed.replace(/<\/ol>\s*<ol>/g, "");

    // Step 2: move bullet descriptions inside previous <li>
    fixed = fixed.replace(
      /<\/li>\s*<\/ol>\s*<ul>\s*<li>(.*?)<\/li>\s*<\/ul>/g,
      "<br>$1</li></ol>",
    );

    return fixed;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      {/* HERO SECTION */}
      <section className="pt-24 sm:pt-28 md:pt-36 pb-8 px-4 text-center bg-gradient-to-br from-green-50 to-blue-50">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            {blog.blog_name}
          </h1>
          <div className="h-1 w-20 bg-green-600 mx-auto mb-4 rounded"></div>
          <p className="text-gray-500 text-sm sm:text-base italic">
            Published on:{" "}
            {blog.created_at
              ? new Date(blog.created_at).toLocaleDateString("en-IN")
              : ""}
          </p>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="py-10 sm:py-14 px-4 overflow-hidden">
        <div className="w-full">
          {/* ✅ IMAGE (smaller width) */}
          {blog.blog_image && (
            <div className="max-w-4xl mx-auto">
              <img
                src={blog.blog_image}
                alt={blog.blog_name}
                className="w-full aspect-video object-cover rounded-xl mb-8 shadow-lg"
              />
            </div>
          )}

          {/* ✅ TEXT (wider + controlled) */}
          <div className="max-w-5xl mx-auto px-2 sm:px-0">
            <div
              className="prose max-w-none text-gray-800 leading-relaxed text-left break-words overflow-hidden"
              dangerouslySetInnerHTML={{
                __html: fixOrderedLists(sanitizedContent),
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 bg-gradient-to-r from-green-100 to-blue-100 text-center">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">
          Want to Read More?
        </h2>
        <button
          onClick={() => navigate("/blogs")}
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold text-sm sm:text-base"
        >
          Back to All Blogs
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default SingleBlogPage;
